import React, { useState } from 'react'
import { Button, Modal, View } from 'oio-react'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { settingsSiteUrl } from 'config/constants/urls'
import EmailActivityIcon from 'assets/icons/emailActivity'
import EmailMessageIcon from 'assets/icons/emailMessage'
import ActionListItemRow from 'src/components/Settings/ActionListItemRow'
import EmailNotificationActivity from 'src/components/EmailNotification/Activity'
import EmailNotificationEditor from 'src/components/EmailNotification/Editor'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'

const SettingsSiteEmailNotifications = () => {
   // TODO: This is a temporary solution to ensure that modals can animate out
   // when the action to close the modal is triggered. A more permanent solution
   // would be to used a state machine that wraps or replaces the Switch below
   // (similar to how TransitionGroup works).
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const history = useHistory()
   const match = useRouteMatch()

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="Site Settings"
            returnLinkTo={settingsSiteUrl}
         />
         <View
            display="flex"
            justifyContent="center">
            <View
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <ProtoHeadingBlock
                     contentMaxWidth="100%"
                     title="Email Notifications"
                     description="View all outgoing emails from this Community and customize the emails that are sent automatically based on certain user actions. You may edit the message body of these automatic emails."
                  />
               </View>
               <View
                  width="100%"
                  marginTop="40px"
                  borderRadius="6px">
                  <ActionListItemRow
                     name="Email Activity"
                     description="See a history of all email activity from your site"
                     action={(
                        <Button
                           linkTo={`${match.url}/email-activity`}
                           width="78px"
                           size="xs"
                           name="View"
                           color="#eee"
                           textColor="#222"
                        />
                     )}
                     icon={(
                        <EmailActivityIcon
                           width="22px"
                           height="22px"
                           strokeWidth="2px"
                           color="#aaa"
                        />
                     )}
                  />
                  <ActionListItemRow
                     name="Community Invitation Email"
                     description="This email is automatically sent to a user when they are invited to join this Community"
                     action={(
                        <Button
                           linkTo={`${match.url}/email-editor/organization.invite`}
                           width="78px"
                           size="xs"
                           name="Edit"
                           color="#eee"
                           textColor="#222"
                        />
                     )}
                     icon={(
                        <EmailMessageIcon
                           width="18px"
                           height="18px"
                           strokeWidth="2px"
                           color="#aaa"
                        />
                     )}
                  />
                  <ActionListItemRow
                     name="Community Welcome Email"
                     description="This email is automatically sent to a user that successfully registers and joins this Community"
                     action={(
                        <Button
                           linkTo={`${match.url}/email-editor/organization.welcome`}
                           width="78px"
                           size="xs"
                           name="Edit"
                           color="#eee"
                           textColor="#222"
                        />
                     )}
                     icon={(
                        <EmailMessageIcon
                           width="18px"
                           height="18px"
                           strokeWidth="2px"
                           color="#aaa"
                        />
                     )}
                  />
               </View>
            </View>
         </View>
         <Switch>
            <Route
               path={`${match.url}/email-activity`}
               render={() => (
                  <Modal
                     borderRadius="6px"
                     overlayBackgroundColor="rgba(20,20,20,0.9)"
                     width="100%[a-b] 90%[c] 960px[d] 1000px[e-f]"
                     height="100%[a-b] 90%[c-f]"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}>
                     <EmailNotificationActivity
                        onCloseButtonClick={() => setModalIsOpen(false)}
                        targetType="organization"
                     />
                  </Modal>
               )}
            />
            <Route
               path={`${match.url}/email-editor/:emailNotificationType`}
               render={() => (
                  <Modal
                     borderRadius="9px"
                     overlayBackgroundColor="rgba(20,20,20,0.9)"
                     width="100%[a-b] 90%[c-d] 1300px[e-f]"
                     height="100%[a-b] 95%[c-f]"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}>
                     <EmailNotificationEditor
                        onCloseButtonClick={() => setModalIsOpen(false)}
                        targetType="organization"
                     />
                  </Modal>
               )}
            />
         </Switch>
      </View>
   )
}

export default SettingsSiteEmailNotifications
